import { render, staticRenderFns } from "./bonusLesson.vue?vue&type=template&id=065aaff6&scoped=true"
import script from "./bonusLesson.vue?vue&type=script&lang=js"
export * from "./bonusLesson.vue?vue&type=script&lang=js"
import style0 from "./bonusLesson.vue?vue&type=style&index=0&id=065aaff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065aaff6",
  null
  
)

export default component.exports